export default __webpack_public_path__ + "static/media/ic_stopwatch_app.2946ade9.svg";